<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import type { WrongRecipientReplacementRow, WrongRecipientReplacementDraft } from "../../contract"
  import { ContactComparisonTag } from "../../../../../../_shared/_modules/contact-comparison-tag"
  import { comparison, previousComparisons } from "../../_shared/_logic/comparison"
  let {
    row,
    draft,
    columnConfig,
  }: InboxWorkflowCellProps<WrongRecipientReplacementRow, WrongRecipientReplacementDraft> = $props()
</script>
<ContactComparisonTag
  value={columnConfig.id === "previousCustomer"
    ? previousComparisons(row)[0]
    : comparison(row, draft)}
/>
